import { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

/** The printable area of the sheet. Every section aligns to these margins. */
export function Sheet({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-sheet px-6 md:px-10', className)}
      {...props}
    >
      {children}
    </div>
  );
}
